function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: 1000,
    height: 422.39017,
    viewBox: "0 0 999.99999 422.39016",
    enableBackground: "new 0 0 1000 608.645",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "g830"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#111212",
      fillOpacity: 1,
      strokeWidth: 1.00007
    },
    d: "M 0,0 V 422.39016 H 127.84344 V 286.06547 H 244.07719 V 170.49177 H 127.84344 V 115.2085 H 270.37039 L 262.63124,0 Z",
    id: "path8051"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8458",
    style: {
      display: "inline",
      fill: "#111212",
      fillOpacity: 1,
      strokeWidth: 1.00007
    },
    d: "M 475.47971,0 C 358.47737,0 264.28366,94.19368 264.28365,211.19606 c 10e-6,117.00233 94.19371,211.1941 211.19606,211.1941 117.00235,0 211.1941,-94.19177 211.1941,-211.1941 C 686.67381,94.19368 592.48206,0 475.47971,0 Z m 0,86.988239 c 19.75546,0 35.65729,15.901801 35.65729,35.657281 v 177.0991 c 0,19.75548 -15.90184,35.65925 -35.65729,35.65925 -19.75546,0 -35.65924,-15.90377 -35.65924,-35.65925 v -177.0991 c 0,-19.75548 15.90378,-35.657281 35.65924,-35.657281 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8456",
    style: {
      display: "inline",
      fill: "#111212",
      fillOpacity: 1,
      strokeWidth: 1.00008
    },
    d: "M 623.31711,0 743.15476,211.19489 623.31711,422.38978 H 760.3266 l 51.33194,-90.46856 51.33387,90.46856 H 1000 L 880.16426,211.19489 1000,0 H 862.99241 L 811.65854,90.466616 760.32856,0 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFox);
export default __webpack_public_path__ + "static/media/Fox.eb2bf7c4df35235af88bdd4cfb7dd8af.svg";
export { ForwardRef as ReactComponent };